// #128 — flags de build do checkout, lidas num lugar só.
// Vite inlina `import.meta.env.*` em build-time: os gates continuam tree-shakeable.

/**
 * Programa de indicação no checkout. Default LIGADO — antes era `=== 'true'`
 * sem default e um deploy sem a var sumia com o bloco de indicação em silêncio.
 * Desligar explicitamente: VITE_REFERRAL_ENABLED=false.
 */
export const REFERRAL_ENABLED = import.meta.env.VITE_REFERRAL_ENABLED !== 'false';

/**
 * Desliga o Turnstile em TODOS os planos (ambiente local/E2E). Não tem efeito
 * silencioso: `TurnstileSkippedBanner` fica visível na tela enquanto ativo.
 */
export const SKIP_TURNSTILE = import.meta.env.VITE_SKIP_TURNSTILE === 'true';

/** Slug do plano quando a URL chega sem um (`/`). */
export const DEFAULT_PLAN_SLUG = import.meta.env.VITE_DEFAULT_PLAN_SLUG || 'descoberta-mensal';

if (SKIP_TURNSTILE) {
  console.warn(
    '⚠️ VITE_SKIP_TURNSTILE=true — verificação antibot DESLIGADA neste build. Nunca em produção.',
  );
}
